import { useEffect, useMemo, useState } from "react";
import { Button } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import enviroments from "../../utils/enviroments";

const getFileName = (file) => {
  if (!file) return "";
  if (file.name) return file.name;
  return String(file).split("/").pop();
};

const FundDocumentPreview = ({ file }) => {
  const [localUrl, setLocalUrl] = useState("");
  const fileName = getFileName(file);
  const isLocalFile = Boolean(file?.name);

  useEffect(() => {
    if (!isLocalFile) {
      setLocalUrl("");
      return undefined;
    }

    const objectUrl = URL.createObjectURL(file);
    setLocalUrl(objectUrl);

    return () => URL.revokeObjectURL(objectUrl);
  }, [file, isLocalFile]);

  const documentUrl = useMemo(() => {
    if (!file) return "";
    if (isLocalFile) return localUrl;
    return `${enviroments.base_url}/uploads/${file}`;
  }, [file, isLocalFile, localUrl]);

  if (!file || !documentUrl) return null;

  return (
    <div className="w-full mb-2 rounded border border-[#bdbdbd] bg-white">
      <div className="flex items-center justify-between gap-3 px-3 py-2 text-gray-600">
        <div className="flex min-w-0 items-center gap-2">
          <TextSnippetIcon sx={{ color: "#3b79bd" }} />
          <span className="truncate text-sm">{fileName}</span>
        </div>
        <div className="flex shrink-0 items-center gap-1">
          <Button
            component="a"
            href={documentUrl}
            target="_blank"
            rel="noreferrer noopener"
            size="small"
            startIcon={<OpenInNewIcon />}
            sx={{ textTransform: "none" }}
          >
            Ver
          </Button>
          <Button component="a" href={documentUrl} download size="small" startIcon={<DownloadIcon />} sx={{ textTransform: "none" }}>
            Descargar
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FundDocumentPreview;
